import { render, staticRenderFns } from "./StaffYearlyAttendance.vue?vue&type=template&id=061cf528&scoped=true&"
import script from "./StaffYearlyAttendance.vue?vue&type=script&lang=js&"
export * from "./StaffYearlyAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061cf528",
  null
  
)

export default component.exports